<template>
  <v-card
    flat
    tile
  >
    <v-card-title class="text-h4">My Account</v-card-title>
    <v-card-text>
      <v-row align="stretch">
        <v-col md=4>
          <AccountDetails></AccountDetails>
        </v-col>
        <v-col md=8>
          <WalletLedger></WalletLedger>
        </v-col>
      </v-row>
      <v-row>
        <v-col md=12>
          <CurrentInvestments></CurrentInvestments>
        </v-col>
        <v-col md=12>
          <PastInvestments></PastInvestments>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
  import { mapActions } from 'vuex'
  import AccountDetails from '../components/user/AccountDetails.vue'
  import WalletLedger from '../components/user/WalletLedger.vue'
  import CurrentInvestments from '../components/user/CurrentInvestments.vue'
  import PastInvestments from '../components/user/PastInvestments.vue'

  export default {
    name: 'UserAccount',

    components: {
      AccountDetails,
      WalletLedger,
      CurrentInvestments,
      PastInvestments
    },

    methods: {
      ...mapActions([
        'getProfile'
      ])
    },

    async created() {
      await this.getProfile()
    }
  }
</script>
